import { render } from "./FlushBorders.vue?vue&type=template&id=80ff628c"
import script from "./FlushBorders.vue?vue&type=script&lang=ts"
export * from "./FlushBorders.vue?vue&type=script&lang=ts"
script.render = render

export default script